// extracted by mini-css-extract-plugin
module.exports = {"root":"MarkdownMessage_root__3I2ik"};